import { jsx as o, jsxs as M } from "react/jsx-runtime";
import { c as z } from "react/compiler-runtime";
import { Typography as O, Divider as F, Accordion as G, Collapse as H, Box as P, AccordionSummary as J, AccordionDetails as K } from "@mui/material";
import L from "@mui/icons-material/ExpandMore";
import { styles as _ } from "./Accordion.style.js";
import { useState as Q } from "react";
function Z(D) {
  const e = z(47);
  let v, s, c, T, l, a, r, n, d, i, g, t;
  e[0] !== D ? ({
    description: s,
    defaultExpanded: v,
    expanded: T,
    summary: n,
    sx: i,
    summarySx: d,
    detailsSx: c,
    onChange: l,
    title: t,
    subTitle: r,
    variant: g,
    ...a
  } = D, e[0] = D, e[1] = v, e[2] = s, e[3] = c, e[4] = T, e[5] = l, e[6] = a, e[7] = r, e[8] = n, e[9] = d, e[10] = i, e[11] = g, e[12] = t) : (v = e[1], s = e[2], c = e[3], T = e[4], l = e[5], a = e[6], r = e[7], n = e[8], d = e[9], i = e[10], g = e[11], t = e[12]);
  const k = g === void 0 ? "detailed" : g, I = typeof t == "string", [m, q] = Q(!!(v || T));
  let b;
  e[13] !== l ? (b = (w, B) => {
    q(B), l && l(w, B);
  }, e[13] = l, e[14] = b) : b = e[14];
  const $ = b, j = `accordion-${k}`;
  let f;
  e[15] !== i ? (f = Array.isArray(i) ? i : [i], e[15] = i, e[16] = f) : f = e[16];
  let x;
  e[17] !== f ? (x = [_.accordion, ...f], e[17] = f, e[18] = x) : x = e[18];
  let C;
  e[19] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ o(L, {}), e[19] = C) : C = e[19];
  let u;
  e[20] !== I || e[21] !== t ? (u = t && (I ? /* @__PURE__ */ o(O, { sx: _.accordionTitle, children: t }) : t), e[20] = I, e[21] = t, e[22] = u) : u = e[22];
  let p;
  e[23] !== r ? (p = r && /* @__PURE__ */ o(O, { sx: _.accordionSubTitle, children: r }), e[23] = r, e[24] = p) : p = e[24];
  let h;
  e[25] !== m || e[26] !== n ? (h = n && /* @__PURE__ */ o(H, { in: !m, timeout: "auto", unmountOnExit: !0, children: /* @__PURE__ */ o(P, { className: "summary-content", children: n }) }), e[25] = m, e[26] = n, e[27] = h) : h = e[27];
  let y;
  e[28] !== u || e[29] !== p || e[30] !== h ? (y = /* @__PURE__ */ M(P, { className: "summary-container", children: [
    u,
    p,
    h
  ] }), e[28] = u, e[29] = p, e[30] = h, e[31] = y) : y = e[31];
  let A;
  e[32] !== d || e[33] !== y ? (A = /* @__PURE__ */ o(J, { expandIcon: C, sx: d, children: y }), e[32] = d, e[33] = y, e[34] = A) : A = e[34];
  let E;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (E = /* @__PURE__ */ o(F, { className: "accordion-separator", sx: _.accordionDivider }), e[35] = E) : E = e[35];
  let S;
  e[36] !== s || e[37] !== c ? (S = /* @__PURE__ */ o(K, { sx: c, children: s }), e[36] = s, e[37] = c, e[38] = S) : S = e[38];
  let N;
  return e[39] !== $ || e[40] !== m || e[41] !== a || e[42] !== A || e[43] !== S || e[44] !== j || e[45] !== x ? (N = /* @__PURE__ */ M(G, { className: j, expanded: m, onChange: $, sx: x, ...a, children: [
    A,
    E,
    S
  ] }), e[39] = $, e[40] = m, e[41] = a, e[42] = A, e[43] = S, e[44] = j, e[45] = x, e[46] = N) : N = e[46], N;
}
export {
  Z as Accordion
};
